/**
 * Prop names whose string values are URLs or link targets. Inline template
 * substitutions in mixed templates on these keys are URL-encoded at runtime.
 */
export const URL_LINK_PROP_NAMES: ReadonlySet<string> = new Set([
  'href',
  'url',
  'ctaHref',
  'link',
  'to',
  'src',
]);
